<template>
  <div v-if="hasError" class="error-boundary">
    <div class="error-content">
      <h2>Что-то пошло не так</h2>
      <p>{{ errorMessage }}</p>
      <button @click="resetError" class="retry-button">
        Попробовать снова
      </button>
    </div>
  </div>
  <slot v-else />
</template>

<script setup>
import { ref, onErrorCaptured } from 'vue'

const hasError = ref(false)
const errorMessage = ref('')

onErrorCaptured((err, instance, info) => {
  console.error('ErrorBoundary caught error:', err, info)
  hasError.value = true
  errorMessage.value = err.message || 'Произошла непредвиденная ошибка'
  
  // Можно отправить ошибку в систему мониторинга
  // sendErrorToMonitoring(err, info)
  
  return false // Предотвращаем дальнейшее распространение ошибки
})

const resetError = () => {
  hasError.value = false
  errorMessage.value = ''
  // Перезагружаем страницу для полного сброса состояния
  window.location.reload()
}
</script>

<style scoped>
.error-boundary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
}

.error-content {
  text-align: center;
  max-width: 500px;
}

.error-content h2 {
  color: #e74c3c;
  margin-bottom: 1rem;
}

.error-content p {
  color: #666;
  margin-bottom: 2rem;
}

.retry-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.retry-button:hover {
  background-color: #2980b9;
}
</style>

